export default {
    init() {
        const tabs = jQuery('section.devices header a');
        const content = jQuery('section.devices .tab-content');
        tabs.on('click', (e) => {
            e.preventDefault();
            tabs.parents('h4').removeClass('active');
            jQuery(e.currentTarget).parent('h4').addClass('active');
            content.hide();
            content.filter(jQuery(e.currentTarget).attr('href')).show();
            jQuery(window).trigger('resize');
        });
        tabs.eq(0).trigger('click');
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/TruckAerodynamics.js